

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';
import { Department } from './department';

export interface PhysicianParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}
export interface MPOMaster {
    name: string;
    code: string;
    email: string;
    mobileNumberCode: string;
    mobileNumber:string;
    status:boolean;
    createdBy?:number;
    updatedBy?:number;
    tenantId:string;
    branchId:string;
    createdDate?:Date;
    updateDate?:Date;
    id?:number;
    mpoId?:number
}
export interface Physician {
    code?:string;
    mpoId?:number
    id?: any;
    tenantId: any;
    branchId: any;
    globalId: string;
    gender: string;
    age: number;
    name: string;
    displayName: string;
    dob: Date;
    email: string;
    workPhone: string;
    mobile: string;
    altMobile: string;
    streetName: string;
    address: string;
    city: string;
    districtId: any
    stateId: any
    countryId: any
    pincode: string
   // councilNum: string;
    panNo: string;
    consultationChargeType:number;

   // councilId: string;
    //photo: any;
    departmentId: any;
    department?: Department;
    jobType:string;
    doctor:string;
    lastName:string;
    
    createdDate?:Date;
    updatedDate?:Date;
    createdBy?:number;
    updatedBy?:number;
    createdIP?:string;
    updatedIP?:string;
    referralType:string | number;
    //******
    // qualification:string;
    // qualification_Dtl:any;
    // experience:string;
    // experience_Dtl:string;
    // accreditation:string;
    // accreditation_Dtl:any;
    
    //Added New Column ***Thenmozhi***15 April 2022***     
    appointmentBookingType:number; 
    newApptAmt:any;
    initiatedwhen: any;
    apptGraceDays: any;
    apptGraceAmt: any;
    defaultLanguage:any;
    englishAlongWithRegLang:any;
    medicineInfoFlag:string;
    assignedBranches?:string;

    jobCategoryId?:number;

    parameters?: PhysicianParameter[];
    links?: any;
}


export abstract class PhysicianData {
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<Physician[]>;
    abstract newlist(url: string): Observable<Physician[]>;
    abstract getById(url: string): Observable<Physician>;
    abstract create(url: string, data: Physician): Observable<Physician[]>;
    abstract update(url: string, data: Physician): Observable<Physician>;
    abstract delete(url: string): Observable<any>;
    abstract searchList(url: string,data:any): Observable<any>;
    abstract createPhysicianSettings(url: string, data: any): Observable<any[]>;
    abstract updatePhysicianSettings(url: string, data: any): Observable<any>;
    abstract getPhysicianSetting(url: string): Observable<any>;
    abstract getFilterList(url: string,options:any): Observable<any>;
    abstract saveMPOMaster(url: string, data: any): Observable<any>;

    
}
